import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

export function QRScanner({ onResult, onClose }) {
  const ref = useRef(null);
  const idRef = useRef(`qr-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    const scanner = new Html5Qrcode(idRef.current);
    ref.current = scanner;
    let stopped = false;
    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: 220 },
        (decoded) => { if (!stopped) { stopped = true; scanner.stop().catch(() => {}); onResult(decoded); } },
        () => {}
      )
      .catch(() => {});
    return () => {
      try { scanner.stop().catch(() => {}); } catch (e) { console.error("QRScanner: arrêt impossible", e); }
    };
  }, [onResult]);

  return (
    <div className="space-y-3">
      <div id={idRef.current} className="rounded-md overflow-hidden bg-black" style={{ width: "100%" }} data-testid="qr-scanner-view" />
      <p className="text-xs text-center text-muted-foreground">Présentez le QR Code PMTi devant la caméra.</p>
    </div>
  );
}
